import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'chatbot',
  initialState: { conversations: [] },
  reducers: {
    setConversations: (state, { payload }) => {
      state.conversations = payload
    },
  },
})

export const { setConversations } = slice.actions

export default slice.reducer

export const selectConversations = (state) => state.chatbot.conversations
